<template>
    <div>
        <table class="lstTable">
            <tr>
                <th v-for="header in headers" :width="header.width">
                    <div :style="header.headerStyle">
                        {{$t(header.text)}}
                    </div>
                </th>
            </tr>
            <tr v-for="(item,index) in items">
                <td class="text-xs-center" :rowspan="item.rowspan" v-if="item.rowspan>0">{{ index+1}}
                </td>
                <td class="text-xs-left" :rowspan="item.rowspan" v-if="item.rowspan>0">
                    {{ item.task }}
                </td>
                <td v-if="item.feeType == 0 || item.feeType== null" colspan="6">
                    {{$t("lang.procedure.nofee")}}
                </td>
                <td class="text-xs-left" v-if="item.feeType != 0 && item.feeType != null">
                    <input type="text" class="tableInput" v-model="item.feeName"/>
                </td>
                <td class="text-xs-left" v-if="item.feeType != 0 && item.feeType != null">
                    <input type="number" class="tableInput" v-model.number="item.official" @input="reCalculateFee"/>
                </td>
                <td class="text-xs-left" v-if="item.feeType != 0 && item.feeType != null">
                    <input type="number" class="tableInput" v-model.number="item.attorney" @input="reCalculateFee"/>
                </td>
                <td class="text-xs-left" v-if="item.feeType != 0 && item.feeType != null">
                    <input type="number" class="tableInput" v-model.number="item.docketing" @input="reCalculateFee"/>
                </td>
                <td class="text-xs-left" v-if="item.feeType != 0 && item.feeType != null">
                    <input type="number" class="tableInput" v-model.number="item.vat" @input="reCalculateFee"/>                
                </td>
                <td class="text-xs-left" v-if="item.feeType != 0 && item.feeType != null">
                    <input type="number" class="tableInput" v-model.number="item.total"/>                
                </td>
                <!--td class="text-xs-left" v-if="item.feeType != 0 && item.feeType != null">
                    <select v-model="item.feeType" class="tableInput">
                        <option value="1">Phí</option>
                        <option value="2">Lệ phí</option>
                    </select>
                </td>
                <td align="center" v-if="item.feeType != 0 && item.feeType != null">
                    <input type="text" class="tableInput" v-model="item.unit"/>
                </td>
                <td align="center" v-if="item.feeType != 0 && item.feeType != null">
                    <input type="number" class="tableInput" v-model="item.fee"/>
                </td-->
                <td align="center">
                    <v-btn depressed outline icon fab dark color="primary" small @click="addFee(item,index)"
                           title="Clear">
                        <v-icon>add</v-icon>
                    </v-btn>
                    <v-btn depressed outline icon fab dark color="red" small @click="deleteFee(index)" title="Clear">
                        <v-icon>delete</v-icon>
                    </v-btn>
                </td>
            </tr>
        </table>
        <div style="text-align: right">
            <v-spacer></v-spacer>
            <v-btn dark class="primary" @click="onSave" width="200">
                {{ $t('lang.common.save') }}
            </v-btn>
            <v-btn @click="onCancel" width="200">
                {{$t("lang.common.cancel")}}
            </v-btn>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import {message} from "@/shared/message";

    export default {
        name: "procedure-fee",
        components: {},
        props: {
            rowsPerPageItems: {
                type: [Array, Number],
                default: () => [10, 20, 30, 40, 50]
            },
        },

        data: () => ({
            showList: true,
            sortField: "",
            orderBy: "asc",
            headers: [
                {
                    text: "lang.common.no",
                    align: "left",
                    sortable: false,
                    search: false,
                    value: "name",
                    width: "5%"
                },
                {
                    text: "lang.procedure.taskName",
                    align: "left",
                    sortable: true,
                    search: true,
                    value: "task",
                    width: "20%"
                },
                {
                    text: "lang.procedure.feeName",
                    align: "left",
                    sortable: true,
                    search: true,
                    value: "feeName",
                    width: "20%"
                },
                {
                    text: "lang.procedure.officialFee",
                    align: "right",
                    sortable: true,
                    search: true,
                    value: "official",
                    width: "5%"
                },
                {
                    text: "lang.procedure.attorneyFee",
                    align: "right",
                    sortable: true,
                    search: true,
                    value: "attorney",
                    width: "5%"
                },
                {
                    text: "lang.procedure.docketing",
                    align: "right",
                    sortable: true,
                    search: true,
                    value: "docketing",
                    width: "5%"
                },
                {
                    text: "lang.procedure.vat",
                    align: "right",
                    sortable: true,
                    search: true,
                    value: "vat",
                    width: "5%"
                },
                {
                    text: "lang.procedure.total",
                    align: "right",
                    sortable: true,
                    search: true,
                    value: "total",
                    width: "5%"
                },
/*
                {
                    text: "lang.procedure.feeType",
                    align: "left",
                    sortable: true,
                    search: true,
                    value: "feeType",
                    width: "10%"
                },
                {
                    text: "lang.procedure.unit",
                    align: "left",
                    sortable: false,
                    search: false,
                    value: "unit",
                    width: "15%"
                },
                {
                    text: "lang.procedure.price",
                    align: "left",
                    sortable: false,
                    search: false,
                    value: "fee",
                    width: "10%"
                },
*/
                {
                    text: "lang.common.actions",
                    align: "left",
                    sortable: false,
                    search: false,
                    width: "20%"
                }
            ],
            lstTask: [],
            items: [],
            search: "",
            err: {
                fullName: [],
                phone: [],
                email: []
            },
            editingItem: null,
            editorData: "",
            pagination: {
                rowsPerPage: 10,
                page: 1,
                totalItems: 0,
            },
            procedure:null,
        }),

        watch: {
            procedure(val) {
                this.getFee();
            }
        },

        created() {
        },
        methods: {
            reCalculateFee() {
                ////console.log(this.items);
                for (let i = 0; i < this.items.length; i++) {
                    this.items[i].rowspan = null;
                }
                ////console.log(this.items);

                for (let i = 0; i < this.items.length; i++) {
                    console.log(this.items[i]);
                    this.items[i].vat = this.items[i].attorney?this.items[i].attorney * 10 / 100:0;
                    this.items[i].total = (this.items[i].official?this.items[i].official:0)
                        + (this.items[i].attorney?this.items[i].attorney:0)
                        + (this.items[i].docketing?this.items[i].docketing:0)
                        + (this.items[i].vat?this.items[i].vat:0); 
                    if (this.items[i].rowspan == null) {
                        this.items[i].rowspan = 1;
                        for (let j = i + 1; j < this.items.length; j++) {
                            if (this.items[j].task == this.items[i].task) {
                                this.items[j].rowspan = 0;
                                this.items[i].rowspan += 1;
                            }
                        }
                    }

                }
                //console.log(this.items);
            },

            viewProcedureFee(procedure){
                this.procedure = procedure;
                this.getFee();
            },

            getFee() {
                axios.post(process.env.VUE_APP_API_URL + "/procedure/fee/list", this.procedure).then(
                    data => {
                        this.$nextTick(
                            () => {
                                this.items = data;
                                this.reCalculateFee();
                            }
                        )
                    }
                )
            },

            addFee(item, index) {
                if (item.feeType == 0 || item.feeType == null) {
                    item.feeType = 1;
                    this.items.splice(index, 1, item);
                } else {
                    let ob = {
                        "procedureId": item.procedureId,
                        "task": item.task,
                        "feeName": "",
                        "feeType": 1,
                        "fee": 0,
                        "unit": "",
                        "status": 1
                    }
                    this.items.splice(index+1, 0, ob);
                }
                this.reCalculateFee();
            },

            deleteFee(index) {
                if (this.items[index].rowspan == 1) {
                    let item = this.items[index];
                    item.feeType = 0;
                    this.items.splice(index, 1, item);
                } else {
                    this.items.splice(index, 1);
                }
                this.reCalculateFee();
            },

            onSave() {
                for(let i=0;i<this.items.length;i++){
                    if(this.items[i].feeType != 0 && this.items[i].feeType != null){
                        if(this.items[i].feeName == null || this.items[i].feeName.trim()==""){
                            message.error("fee name is not allow null");
                            return;
                        }
/*
                        if(this.items[i].unit == null || this.items[i].unit.trim()==""){
                            message.error("Unit is not allow null");
                            return;
                        }
                        if(this.items[i].fee == null || this.items[i].fee<=0 ){
                            message.error("price is not allow null and less or equal 0");
                            return;
                        }
*/
                    }
                }
                axios.post(process.env.VUE_APP_API_URL + "/procedure/fee/saveAll?procedureId="+this.procedure.procedureId, this.items).then(
                    data => {
                        if (data.success) {
                            message.success(this.$t("lang.common.update_success"));
                            this.getFee();
                            this.onCancel();
                        } else {
                            message.error(data.description);
                        }
                    }
                )
            },

            onCancel() {
                if (this.showEmail) {
                    this.showEmail = false;
                } else {
                    this.$emit("cancel");
                }
            }


        }
    };
</script>